import React, { useState, useRef, useEffect } from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { FaRupeeSign } from "react-icons/fa";
import { ColorRing } from "react-loader-spinner";
import { toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import Select from "react-select";
import "./index.css";

const Index = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [salaried, setSalaried] = useState(false);
  const [cmpList, setCmpList] = useState([]);
  const [validated, setValidated] = useState(false);
  const [check1, setCheck1] = useState(false);
  const [check2, setCheck2] = useState(false);
  const inputRefs = useRef([]);
  const [otpField, setOtpField] = useState("");
  const [show, setShow] = useState(false);
  const [cmpModal, setCmpModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [numberError, setNumberError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [otpLoader, setOtpLoader] = useState(false);
  const [stgOne, setStgOne] = useState("");
  const [stgTwo, setStgTwo] = useState("");
  const [mbl, setMbl] = useState("");
  const [formId, setFormId] = useState("");
  const [data, setData] = useState({
    fname: "",
    lname: "",
    email: "",
    mobile: "",
    profession: "",
    company: "",
    monthly_income: "",
    monthly_emi: "",
    loan_type: "pl",
  });

  const handleSubmit = async (event) => {
    event.preventDefault();
    gtag_report_conversion();
    setValidated(true);
    if (
      data.fname &&
      data.lname &&
      data.email &&
      data.mobile &&
      data.profession !== "Your profession" &&
      data.monthly_income &&
      data.monthly_emi &&
      check2
    ) {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (data.mobile.length < 10) {
        setNumberError(true);
        return false;
      } else if (!regex.test(data.email)) {
        setEmailError(true);
        return false;
      } else {
        setValidated(false);
        try {
          setLoader(true);
          const response = await axios.post(
            "http://loanapi.minemi.ai/api/login",
            data
          );

          if (response.data.status) {
            setStgOne(response.data.data.expData.stgOneHitId);
            setStgTwo(response.data.data.expData.stgTwoHitId);
            setFormId(response.data.data.formId);
            setMbl(data.mobile);
            setShow(true);
            setLoader(false);
          }

          if (!response.data.status) {
            const errors = response.data.msg
              ? response.data.msg
              : response.data.errors;
            toast.error(errors);
          }

          setLoader(false);
        } catch (error) {
          console.error("Error making POST request", error);
          setLoader(false);
        }
      }
    }
  };

  const otpSubmit = async () => {
    setOtpLoader(true);
    // const concatenateOtp = otpField.join("");
    if (otpField.length !== 6) {
      toast.error(
        "Please enter the 6-digit OTP sent to your registered mobile number!"
      );
      setOtpLoader(false);
    } else {
      let formData = new FormData();
      formData.append("stgOneHitId", stgOne);
      formData.append("stgTwoHitId", stgTwo);
      formData.append("otp", otpField);
      formData.append("mobile", mbl);
      formData.append("formId", formId);
      formData.append("type", "CUSTOM");
      try {
        const response = await axios.post(
          "http://loanapi.minemi.ai/api/verifyOtp",
          formData
        );
        setOtpLoader(false);

        if (response.data.status) {
          resetOtp();
          setShow(false);
          localStorage.setItem("username", data.fname + " " + data.lname);
          sessionStorage.setItem("fId", formId);
          localStorage.setItem("eligibleData", JSON.stringify(response.data));
          navigate("/loan-eligibility", {
            replace: true,
            state: { isValid: true },
          });
        }

        if (!response.data.status) {
          toast.error(response.data.msg);
        }
      } catch (error) {
        console.error("Error making POST request", error);
        setOtpLoader(false);
      }
    }
  };

  const handleChange = async (event, cName = null) => {
    let name = null;
    let value = null;

    if (cName === null) {
      name = event.target.name;
      value = event.target.value;
    } else {
      name = cName;
      value = event.value;
    }

    if (
      name === "mobile" ||
      name === "monthly_income" ||
      name === "monthly_emi" ||
      name === "email"
    ) {
      if (name === "mobile") {
        const numericValue = value.replace(/\D/g, "").slice(0, 10);
        (numericValue.length < 1 || numericValue.length >= 10) &&
          setNumberError(false);

        setData((oldData) => ({
          ...oldData,
          [name]: numericValue,
        }));

        numericValue.length >= 1 &&
          numericValue.length < 10 &&
          setNumberError(true);
      } else if (name === "email") {
        setData((oldData) => ({
          ...oldData,
          [name]: value,
        }));
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        regex.test(value) ? setEmailError(false) : setEmailError(true);
      } else {
        const plainNumber = parseFloat(value.replace(/,/g, ""));
        let fValue = plainNumber >= 0 ? plainNumber : "";

        setData((oldData) => ({
          ...oldData,
          [name]: fValue,
        }));
      }
    } else if (name === "profession") {
      if (value === "Salaried") {
        setSalaried(true);
        setCmpModal(true);
        const response = await axios.get(
          `${process.env.REACT_APP_SECRET_KEY}/companyList`
        );
        if (response.status === 200) {
          let cmpArray = response.data.data.company;
          const formattedOptions = cmpArray.map((option) => ({
            value: option.id,
            label: option.company_name,
          }));
          setCmpList(formattedOptions);
        }
        setCmpModal(false);
      } else {
        setSalaried(false);
      }

      setData((oldData) => ({
        ...oldData,
        [name]: value,
      }));
    } else {
      setData((oldData) => ({
        ...oldData,
        [name]: value,
      }));
    }
  };

  const otpHandleChange = (element) => {
    let value = element.value.replace(/[^0-9]/g, "");
    value = value.slice(0, 6);
    setOtpField(value);
  };

  const handleClick = (name) => {
    navigate("/experian-terms-and-conditions", { state: { name } });
  };

  const resetOtp = () => {
    setOtpField("");
  };

  useEffect(() => {
    localStorage.removeItem("termData");
    localStorage.removeItem("eligibleData");
    localStorage.removeItem("username");
    sessionStorage.removeItem("fId");
    const routeData = location.state;
    if (routeData !== null) {
      toast.warning(routeData.msg);
      navigate(location.pathname, { state: null });
    }
  }, []);

  const gtag_report_conversion = () => {
    if (typeof window.gtag !== "undefined") {
      window.gtag("event", "conversion", {
        send_to: "AW-16847657594/W1BOCO3G9ZcaEPq0y-E-",
        value: 1.0,
        currency: "INR",
        event_callback: () => console.log("Conversion tracked"),
      });
      return true; // Returning true if gtag exists
    } else {
      console.error("gtag is not available");
      return false; // Returning false in case of an error
    }
  };

  return (
    <>
      <div id="findLoan">
        <div className="contentCon">
          <div className="row m-0 p-0">
            <div className="col-12 col-md-8 ps-0 m-0 top-con">
              <div className="title-con">
                <p className="find-text p-0 m-0">
                  FIND YOUR <b>PERSONAL</b>
                </p>
                <p className="p-0 m-0 d-flex justify-content-center align-items-center">
                  <span className="loan-text">loan eligibility</span>
                  <span className="offer-text">OFFER</span>
                </p>
              </div>
              <img
                src="images/home/magnify.png"
                alt="magnify"
                id="magnify-img"
              />
              <div className="desc-con">
                <p className="p-0 first-text">Did you know?</p>
                <p className="p-0 second-text">
                  Every time you check your loan eligibility, you might impact
                  your credit score?
                </p>
                <p className="p-0 third-text">
                  That is because most often, you are't just checking
                  eligibility but also unwittingly applying for the loan.
                  However, with minEMI, you don't accfect credit score because
                  it's not an enquiry yet and won't even be, unless you make it
                  one.
                </p>
              </div>
            </div>

            <div className="col-12 col-md-4 p-0 m-0">
              <div id="form-main-con">
                <div id="form-header">
                  <p className="title">
                    Find Personal Loan Eligibility & Best Interest Offer
                  </p>
                  <p className="subtitle">without impacting credit Score</p>
                </div>
                <div id="form-con">
                  <Form noValidate onSubmit={handleSubmit}>
                    <Form.Control
                      required
                      type="text"
                      placeholder="Enter your first name"
                      className="inputs"
                      name="fname"
                      value={data.fname}
                      onChange={handleChange}
                    />
                    {validated && !data.fname && (
                      <p className="field-error">
                        First name is required field
                      </p>
                    )}

                    <Form.Control
                      required
                      type="text"
                      placeholder="Enter your last name"
                      className="inputs"
                      value={data.lname}
                      name="lname"
                      onChange={handleChange}
                    />
                    {validated && !data.lname && (
                      <p className="field-error">Last name is required field</p>
                    )}

                    <Form.Control
                      required
                      type="text"
                      placeholder="Enter your email"
                      className="inputs"
                      value={data.email}
                      name="email"
                      onChange={handleChange}
                    />
                    {validated && !data.email && (
                      <p className="field-error">Email is required field</p>
                    )}
                    {emailError && <p className="field-error">Invalid Email</p>}

                    <InputGroup className="w-100">
                      <InputGroup.Text className="mbl-text">
                        +91
                      </InputGroup.Text>
                      <Form.Control
                        required
                        type="text"
                        maxLength={10}
                        placeholder="Enter your contact number"
                        className="mbl-input"
                        name="mobile"
                        value={data.mobile}
                        onChange={handleChange}
                      />
                    </InputGroup>
                    {validated && !data.mobile && (
                      <p className="field-error">Number is required field</p>
                    )}
                    {numberError && (
                      <p className="field-error">Number must be 10 digits</p>
                    )}

                    <Form.Select
                      className="profession"
                      required
                      value={data.profession}
                      name="profession"
                      onChange={handleChange}
                    >
                      <option value="Your profession">Your profession</option>
                      <option value="Salaried">Salaried</option>
                      <option value="Self-Employed">Self-Employed</option>
                      <option value="Others">Others</option>
                    </Form.Select>
                    {validated &&
                      (!data.profession ||
                        data.profession === "Your profession") && (
                        <p className="field-error">
                          Profession is required field
                        </p>
                      )}

                    {/* {salaried &&  <Form.Select className='profession' required value={data.company} name="company" onChange={handleChange} >
                                        {cmpList.map((item,index)=>(
                                            <option value={item.value} key={index}>{item.label}</option>
                                        ))}
                                    </Form.Select>} */}

                    {salaried && (
                      <Select
                        defaultValue={data.company}
                        onChange={(event) => handleChange(event, "company")}
                        options={cmpList}
                        placeholder="Select Company"
                      />
                    )}
                    {salaried && validated && !data.company && (
                      <p className="field-error">
                        Company name is required field
                      </p>
                    )}

                    <InputGroup className="w-100">
                      <InputGroup.Text className="rupee-icon">
                        <FaRupeeSign color="#59266D" className="icons" />
                      </InputGroup.Text>
                      <Form.Control
                        required
                        placeholder="Your monthly income"
                        className="input-groups"
                        value={
                          data.monthly_income === 0 || data.monthly_income
                            ? new Intl.NumberFormat("en-IN").format(
                                data.monthly_income
                              )
                            : ""
                        }
                        name="monthly_income"
                        onChange={handleChange}
                      />
                      {/* <InputGroup.Text className="group-text d-flex justify-content-end">
                        (In Rupees)
                      </InputGroup.Text> */}
                    </InputGroup>
                    {validated && !data.monthly_income && (
                      <p className="field-error">
                        Monthly income is required field
                      </p>
                    )}

                    <InputGroup className="w-100">
                      <InputGroup.Text className="rupee-icon">
                        <FaRupeeSign color="#59266D" className="icons" />
                      </InputGroup.Text>
                      <Form.Control
                        required
                        placeholder="Your monthly EMI"
                        className="input-groups"
                        value={
                          data.monthly_emi === 0 || data.monthly_emi
                            ? new Intl.NumberFormat("en-IN").format(
                                data.monthly_emi
                              )
                            : ""
                        }
                        name="monthly_emi"
                        onChange={handleChange}
                      />

                      {/* <InputGroup.Text className="group-text d-flex justify-content-end">
                        (In Rupees)
                      </InputGroup.Text> */}
                    </InputGroup>
                    {validated && !data.monthly_emi && (
                      <p className="field-error">
                        Monthly EMI is required field
                      </p>
                    )}

                    <div id="checkbox-con">
                      <div className="d-flex">
                        <input
                          type="checkbox"
                          onChange={(e) => setCheck1(e.target.checked)}
                          className="form-check-input"
                        />
                        <label className="form-check-label">
                          I agree to MinEMI's{" "}
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              handleClick("term_of_use");
                            }}
                          >
                            Terms of Use
                          </a>{" "}
                          and{" "}
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              handleClick("privacy_policy");
                            }}
                          >
                            Privacy Policy
                          </a>{" "}
                          and authorise to be communicated via SMS, Call,
                          Whatsapp and Email. I hereby also allow MinEMI to
                          access my credit report on my behalf
                        </label>
                      </div>
                      {validated && !check1 && (
                        <p className="field-error ms-4">
                          You must agree before submitting.
                        </p>
                      )}

                      <div className="d-flex mt-2">
                        <input
                          type="checkbox"
                          onChange={(e) => setCheck2(e.target.checked)}
                          className="form-check-input"
                        />
                        <label className="form-check-label">
                          I allow Nine Triangles Pvt. Ltd to access my credit
                          report from RBI approved credit bureaus on an ongoing
                          basis for not exceeding 6 months. I also agree to{" "}
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              handleClick("experian_consent");
                            }}
                          >
                            Experian Terms and Conditions.
                          </a>
                        </label>
                      </div>

                      {validated && !check2 && (
                        <p className="field-error ms-4">
                          You must agree before submitting.
                        </p>
                      )}

                      <div className="d-flex flex-column align-items-center mt-2">
                        <p className="empowered-text">Empowered By</p>
                        <img src="images/experian.png" alt="experian.png" />
                      </div>
                      <div className="d-flex justify-content-center">
                        {!loader ? (
                          <Button type="submit">Check Eligibility Now!</Button>
                        ) : (
                          <Button type="button">
                            <ColorRing
                              visible={loader}
                              height="30"
                              width="30"
                              ariaLabel="color-ring-loading"
                              wrapperStyle={{}}
                              wrapperClass="color-ring-wrapper"
                              colors={[
                                "#ffffff",
                                "#ffffff",
                                "#ffffff",
                                "#ffffff",
                                "#ffffff",
                                "#ffffff",
                              ]}
                            />
                          </Button>
                        )}
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Start : Company modal */}
        {cmpModal && (
          <div id="cmpOverlay">
            <ColorRing
              visible={true}
              height="60"
              width="60"
              ariaLabel="color-ring-loading"
              wrapperStyle={{}}
              wrapperClass="color-ring-wrapper"
              colors={[
                "#ffffff",
                "#ffffff",
                "#ffffff",
                "#ffffff",
                "#ffffff",
                "#ffffff",
              ]}
            />
          </div>
        )}

        {/* Start : otp modal */}
        <Modal
          size="lg"
          show={show}
          onHide={() => {
            setShow(false);
            resetOtp();
          }}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton className="border-0"></Modal.Header>
          <Modal.Body>
            <div className="row" id="otpCon">
              <div className="col-lg-6 px-0">
                <img src="images/home/auth.png" />
              </div>

              <div className="col-lg-6" id="otp-section">
                <div>
                  <p className="m-0 p-0 otp-text">Enter OTP</p>
                  <p className="m-0 p-0 otp-desc">
                    Please enter the one-time password (OTP) sent on the given
                    number - {data.mobile}
                  </p>
                </div>

                <div
                  className="otp-input-con"
                  // onPaste={handlePaste}
                >
                  {/* {otpField.map((digit, index) => ( */}
                  {/* <input
                      type="otp"
                      // className="otp-inputs"
                      // key={index}
                      maxLength="6"
                      value={otpField}
                      autoComplete="one-time-code"
                      onChange={(e) => otpHandleChange(e.target, index)}
                      // onKeyDown={(e) => handleKeyDown(e, index)}
                      // onPaste={index === 0 ? handlePaste : undefined}
                      // ref={(el) => (inputRefs.current[index] = el)}
                    /> */}

                  <input
                    type="text"
                    maxLength="6"
                    className="otp-single-input"
                    value={otpField}
                    onChange={(e) => otpHandleChange(e.target)}
                  />

                  {/* ))} */}
                </div>

                <div className="otpBtn">
                  {!otpLoader ? (
                    <Button id="verify-btn" onClick={otpSubmit}>
                      Verify
                    </Button>
                  ) : (
                    <Button id="verify-btn">
                      <ColorRing
                        visible={otpLoader}
                        height="30"
                        width="30"
                        ariaLabel="color-ring-loading"
                        wrapperStyle={{}}
                        wrapperClass="color-ring-wrapper"
                        colors={[
                          "#ffffff",
                          "#ffffff",
                          "#ffffff",
                          "#ffffff",
                          "#ffffff",
                          "#ffffff",
                        ]}
                      />
                    </Button>
                  )}
                  <Button id="resend-otp" onClick={handleSubmit}>
                    Resend OTP
                  </Button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default Index;
